import * as React from 'react';
import { CampaignSpec } from '../../../types/membershipPlans';
import { CampaignListItem } from './CampaignListItem';
import './campaignList.module.scss';

type Props = {
  campaigns: CampaignSpec[];
};
export const CampaignList = ({ campaigns }: Props) => {
  return (
    <div styleName="campaign-list">
      {campaigns.map((c) => (
        <CampaignListItem key={c.type} campaign={c} />
      ))}
    </div>
  );
};
